import { TRANSITION_MEDIUM } from '../constants/constants';
import { isMobileScreen, isMobileDevice } from '../Helper/helper';

document.addEventListener("DOMContentLoaded", function() {

	let isMobile = isMobileScreen();
	const IS_MOBILE_DEVICE = isMobileDevice();
	const SECTIONS = $('.article__section');
	const CLASS_TITLE = '.article__section-title';
	const CLASS_CONTENT = '.article__section-content';

	window.addEventListener("resize", function() {
		// resize should be catched on desktop only!
		if (IS_MOBILE_DEVICE) return;
		// Update isMobileDevice
		isMobile = isMobileScreen();
		// Make sure all accordion sections are visible on desktop and folded on mobile
		SECTIONS.each(function() {
			const title = $(this).find(CLASS_TITLE);
			const content = $(this).find(CLASS_CONTENT);
			if (isMobile) {
				$(this).addClass('section-item');
				$(title).addClass('section-button');
				$(content).addClass('section-content');
				title.attr('aria-expanded', false);
				title.addClass('collapsed');
				content.attr('aria-hidden', true);
				content.removeAttr('style');
			} else {
				$(this).removeClass('section-item');
				$(title).removeClass('section-button');
				$(content).removeClass('section-content');
				// content.slideToggle(TRANSITION_MEDIUM);
				title.attr('aria-expanded', true);
				title.removeClass('collapsed');
				content.attr('aria-hidden', false);
				content.removeAttr('style');
			}
		});
	});

	// Mobile Viewport: H2 titles become accordions, content is hidden
	const initMobileSectionAccordion = () => {
		SECTIONS.each(function() {
			const title = $(this).find(CLASS_TITLE);
			const content = $(this).find(CLASS_CONTENT);
			if (isMobile) {
				$(this).addClass('section-item');
				$(title).addClass('section-button');
				$(content).addClass('section-content');
			}
			// OnClick
			title.on('click', function() {
				if (isMobile) {
					content.slideToggle(TRANSITION_MEDIUM);
					content.toggleClass('show');
					const expanded = title.attr('aria-expanded') === 'true' || false;
					title.attr('aria-expanded', !expanded);
					title.toggleClass('collapsed');
					content.attr('aria-hidden', expanded);
				}
			});
		});
	}

	initMobileSectionAccordion();

	// Multi-Pager Side Nav (Dropdown on Desktop)
	// Toggle dropdown menu visibility
	const dropdownToggleList = Array.from(document.querySelectorAll('.side-subpages__toggle'));
	dropdownToggleList.forEach(dropdownToggle => {
		dropdownToggle.addEventListener('click', function() {
			const parentDropdown = this.closest('.side-subpages');
			const dropdownMenu = parentDropdown.querySelector('.side-subpages__menu');
			if (dropdownMenu) {
				dropdownToggle.classList.toggle('active');
				dropdownMenu.classList.toggle('show');
			}
		});
	});

	// Close dropdown menu when clicking outside
	document.addEventListener('click', function(event) {
		dropdownToggleList.forEach(dropdownToggle => {
			const parentDropdown = dropdownToggle.closest('.side-subpages');
			const dropdownMenu = parentDropdown.querySelector('.side-subpages__menu');
			if (!parentDropdown.contains(event.target)) {
				dropdownToggle.classList.remove('active');
				dropdownMenu.classList.remove('show');
			}
		});
	});
});


// Single-Pager (Accordions on Desktop and Mobile)
// User clicks on an anchor link, the related accordion opens

const domReady = (cb) => {
  // Function to call the callback if the document is ready
  const callIfReady = () => {
    if (document.readyState === 'interactive' || document.readyState === 'complete') {
      cb();
    }
  };
  // Call the callback if the document is already in an acceptable state
  callIfReady();
  // Listen for the DOMContentLoaded event in case the document is not yet ready
  document.addEventListener('DOMContentLoaded', cb);
  // Listen for changes in the hash part of the URL
  window.addEventListener('hashchange', cb);
};


domReady(() => {

	const TRANSITION = 0;
	// On Mobile Sections act as accordions 
	const SECTION = 'section-item';
	const SECTION_ITEM = '.' + SECTION;
	const SECTION_BUTTON = '.section-button';
	const SECTION_CONTENT = '.section-content';

	// One-Pager include accordions
	const ACCORDION = 'accordion-item';
	const ACCORDION_ITEM = '.' + ACCORDION;
	const ACCORDION_BUTTON = '.accordion-button';
	const ACCORDION_CONTENT = '.accordion-collapse';

  if (window.location.hash) {
    const id = window.location.hash;
    const ce = $(id);

    let accordionHeader;
    let accordionBody;

		// Section ID
    if (ce.hasClass(SECTION)) {
      accordionHeader = ce.find(SECTION_BUTTON);
      accordionBody = ce.find(SECTION_CONTENT);
    } else {
      accordionHeader = ce.closest(SECTION_ITEM).find(SECTION_BUTTON);
      accordionBody = ce.closest(SECTION_CONTENT);
    }
    if (accordionHeader.length) {
      if (!accordionBody.hasClass('show')) {
        accordionHeader.attr('aria-expanded', 'true');
        accordionHeader.removeClass('collapsed');
        accordionBody.addClass('show');
        accordionBody.slideDown(TRANSITION, function() {
    			// Animation complete, then scroll to the id
    			setTimeout(() => { 
	    			document.getElementById(id.replace('#', '')).scrollIntoView({
			        behavior: 'smooth',
			        block: 'start' // Aligns the element at the top of the viewport
				    });
			    }, 200);
  			});
      }
    } else {
			// Accordion ID
      if (ce.hasClass(ACCORDION)) {
        accordionHeader = ce.find(ACCORDION_BUTTON);
        accordionBody = ce.find(ACCORDION_CONTENT);
      } else {
        accordionHeader = ce.closest(ACCORDION_ITEM).find(ACCORDION_BUTTON);
        accordionBody = ce.closest(ACCORDION_CONTENT);
      }
      console.log(accordionHeader, accordionBody);
      if (!accordionBody.hasClass('show')) {
        accordionHeader.attr('aria-expanded', 'true');
        accordionBody.addClass('show');
      }
  	}
  }

});
